<template>
  <div class="layout layout--dashboard layout--admin">
    <app-header fixed />
    <div class="layout__content" :class="{ 'layout__content--fluid': fluid }">
      <admin-nav />
      <slot />
    </div>
  </div>
</template>

<script>
import AdminNav from '@/components/app/AdminNav';
import AppHeader from '@/components/app/AppHeader';

export default {
  name: 'dashboard-layout',
  props: {
    fluid: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    AdminNav,
    AppHeader,
  },
};
</script>

<style lang="scss">
.layout {
  &--dashboard {
    flex-direction: row;
  }

  &--admin {
    background-color: color('background', 'dark') !important;
    color: color('text');
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 auto;

    &--fluid {
      max-width: 100%;
      padding: 0;
    }
  }
}
</style>
